export interface ContractEmailTemplate {
  id?: number;
  name: string;
  subject_template: string;
  body_template: string;
  days_after_start: number;
  allowed_funding_statuses: string[];
  is_active: boolean;
  send_to_customer: boolean;
  send_to_dealer: boolean;
  send_to_agent: boolean;
  send_to_lienholder: boolean;
  send_to_obligor: boolean;
  attachment?: File | any;
  product_id?: number;
  created_at?: string;
  updated_at?: string;
}

export interface ContractEmailTemplateResponse {
  id: number;
  name: string;
  subject_template: string;
  body_template: string;
  days_after_start: number;
  allowed_funding_statuses: string[];
  is_active: boolean;
  send_to_customer: boolean;
  send_to_dealer: boolean;
  send_to_agent: boolean;
  send_to_lienholder: boolean;
  send_to_obligor: boolean;
  attachment?: any;
  attachment_url?: string;
  product_id: number;
  created_at: string;
  updated_at: string;
}

export interface ContractEmailTemplateListParams {
  search?: string;
  page?: number;
  per_page?: number;
  is_active?: boolean;
  product_id?: number;
}

// Funding status constants
export const FUNDING_STATUSES = [
  { value: 'Not Funded', label: 'Not Funded' },
  { value: 'Under Funded', label: 'Under Funded' },
  { value: 'Over Funded', label: 'Over Funded' },
  { value: 'Fully Funded', label: 'Fully Funded' },
];

// Default funding statuses as per requirements
export const DEFAULT_FUNDING_STATUSES = ['Not Funded', 'Under Funded'];
